import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type SecondFactorFormArgs = {
	code: string;
};

@ValidatedClass()
class SecondFactorFormData extends AbstractValidatedClass<SecondFactorFormArgs> {
	@constraint(Joi.string().pattern(/^\d{6}$/), () => 'Le code doit comporter 6 chiffres')
	public readonly code: string;

	constructor(data: SecondFactorFormArgs) {
		super(data);
		this.code = data.code;
		Object.freeze(this);
	}

	static createEmpty(): SecondFactorFormData {
		return new SecondFactorFormData({ code: '' });
	}

	setCode(code: string): this {
		return this.cloneWith({ code } as Partial<SecondFactorFormArgs>);
	}
}

export default SecondFactorFormData;
